import $ from 'jquery';
import 'slick-carousel';

export default class ResourcesSlider {
    constructor() {
        this.selector = '.b-additional-resources';
    }

    bootstrap() {
        if ($(this.selector).length > 0) {
            let sliderWrap = $(this.selector).find('.b-additional-resources__cnt');
            if (window.innerWidth < 992) {
                sliderWrap.slick({
                    speed: 300,
                    autoplay: false,
                    autoplaySpeed: 0,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    centerMode: true,
                    arrows: false,
                });
            }
            $(window).resize(function (e) {
                if (window.innerWidth < 992) {
                    if (!sliderWrap.hasClass('slick-initialized')) {
                        sliderWrap.slick({
                            speed: 300,
                            autoplay: false,
                            autoplaySpeed: 0,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            variableWidth: true,
                            centerMode: true,
                            arrows: false,
                        });
                    }
                } else {
                    if (sliderWrap.hasClass('slick-initialized')) {
                        sliderWrap.slick('unslick');
                    }
                }
            });

        }
    }
}
